import React, { Component } from "react";
import { Provider } from "react-redux";
import { authStore } from "../../store/store";
import { Route, Switch } from "react-router-dom";
import Footer from "../../../home/components/Footer/footer.component";
import RolesList from "./RolesList/RolesListPage.component";

import "./RolesManagement.component.scss";
import { isAdmin } from "../../../../utils/Authorization/authorization";

class RolesManagementPage extends Component {
    render() {
        return (
            <Provider store={authStore}>
                <div id="RolesManagementPage">
                    <Switch>
                        {isAdmin() && (
                            <Route
                                exact
                                path={"/roles/"}
                                component={RolesList}
                            />
                        )}
                    </Switch>
                    <Footer />
                </div>
            </Provider>
        );
    }
}

export default RolesManagementPage;
